import React from 'react';
import PropTypes from 'prop-types';

const CopyIcon = ({ size = '14px', height = '16px', fill = '#aaaa' }) => (
  <svg
    id="CopyIcon"
    height={height}
    width={size}
    viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.11111 1.37879V0H10.8889C12.6071 0 14 1.23472 14 2.75758V12.4091H12.4444V2.75758C12.4444 1.99547 11.748 1.37879 10.8889 1.37879H3.11111Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 4.13636C0 3.37426 0.696459 2.75758 1.55556 2.75758H9.33333C10.1924 2.75758 10.8889 3.37426 10.8889 4.13636V13.7879C10.8889 14.55 10.1924 15.1667 9.33333 15.1667H1.55556C0.696459 15.1667 0 14.55 0 13.7879V4.13636ZM1.55556 4.13636H9.33333V13.7879H1.55556V4.13636Z"
      fill={fill}
    />
  </svg>
);

CopyIcon.propTypes = {
  size: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
};
export default CopyIcon;
